<template>
    <div class="mainCon">
        <stu-main-title></stu-main-title>
        <div class="content">
            <ots-table
                v-if="!showNull"
                :tableHeader="tableHeader"
                :tableData="tableData"
            ></ots-table>
            <div v-else class="noScore">
                <img src="@/assets/stuImg/nothing.png" alt="">
                <span class="col_grayQ">暂无考试，请等待</span>
            </div>
        </div>
    </div>
</template>
<script>
import { getExamList, goOtsStartExam, arrangementInfo } from '@/http/modules/student/exam'
export default {
    name: 'stuExam',
    data () {
        return {
            showNull: true,
            tableHeader: [
                {
                    title: '考试名称',
                    prop: 'arrangementName',
                },
                {
                    title: '考试时间',
                    formatter: (val) => `${val.row.beginTime} --- ${val.row.endTime}`
                },
                {
                    title: '操作',
                    type: "buttons",
                    width: "200",
                    btnList:[
                        {
                            title: "开始考试",
                            click: this.startExam,
                            // disableFn: (val) => val.row.type == 1? false : true,
                        },
                    ]
                },
            ],
            tableData: [],
            ip: '',
        }
    },
    created () {
        this.getExam();
    },
    methods: {
        async getExam () {
            const { data } = await getExamList()
            this.tableData = data
            if (this.tableData.length) {
                this.showNull = false
            }
        },
        async startExam (row) {
            if (!(row && row.arrangementId)) {
                this.$message.error('数据有误')
                return false
            }

            const ipInfo = await arrangementInfo({ ip: this.ip });
            if (ipInfo.code == 0) {
                return false;
            }

            let param = {
                action: 'StartTestNormal',
                parames: `arrangementId=${row.arrangementId}`
            }
            const { code, data } = await goOtsStartExam(param)
            if (code == 1) {
                window.open(data)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.mainCon {
    box-sizing: border-box;
    padding: 20px;
    padding-top: 16px;
    width: 100%;
    min-width: 700pt;
    background: rgba(255, 255, 255, 0.93);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    .content {
        padding-top: 20px;
        .noScore {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 40px;
            padding-bottom: 80px;
        }
    }
}
/deep/ .el-table th, .el-table tr {
    background-color: #EBECFF!important;
}
</style>